import { render, staticRenderFns } from "./CurrentRental10gWifiRouter.vue?vue&type=template&id=ba2aae92&scoped=true&"
import script from "./CurrentRental10gWifiRouter.vue?vue&type=script&lang=ts&"
export * from "./CurrentRental10gWifiRouter.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentRental10gWifiRouter.vue?vue&type=style&index=0&id=ba2aae92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2aae92",
  null
  
)

export default component.exports